import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi, { IExistingBorrowerRequest } from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createExistingBorrowerCheckThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(
    ApplyProcessActionTypes.CheckExistingBorrower,
    async (data: IExistingBorrowerRequest) => {
      const response = await api.existingBorrowerCheck(data);
      return response;
    },
  );
